import React, {useState} from 'react';
import axios from 'axios'
import {
    Button,
    Card,
    CardBody,
    Form,
    FormGroup,
    Label,
    Input,
    Alert
} from 'reactstrap'
import { Navigate } from 'react-router-dom'

const AdminRegister = props => {
    const [modal, setModal] = useState()
    const [redirect, setRedirect] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [email, setEmail] = useState('')
    const [name, setName] = useState('')
    const [password, setPassword] = useState('')
    const [password2, setPassword2] = useState('')
    const [company_id, setCompany_id] = useState('')

    // To Redirect to the home page when login 2 paths in which causes an error
    if(redirect){
        return <Navigate replace to='/' state={{ requireRefresh: true }} />
    }

    // Function to open and close login modal
    const toggle = () => {
        setModal(!modal)
    }

    // Login Function
    const submitRegister = async e => {
        e.preventDefault()
        const registerDetails = {
            name,
            email,
            password,
            password2,
            company_id,
            permissionLevel: "Admin"
        }



        await axios.post('api/auth/register',registerDetails)
        .then(res => {
            localStorage.setItem('token', res.data.token)
            setRedirect(true)
        })
        .catch(err => {
            localStorage.clear()
            console.log(err.response)
            setErrorMessage(err.response.data.message)
        })
    }

        return (
            <div className='auth-page-shell'>
                <Card
                    isOpen={modal}
                    toggle={toggle}
                    className='auth-card'
                >
                    <div className='auth-card__header'>
                        <span className='eyebrow'>Admin Access</span>
                        <h1 className='section-title' style={{ fontSize: '1.8rem' }}>Create an admin account</h1>
                        <p className='section-lead'>Register an administrator profile for FoBK operations and event management.</p>
                    </div>
                    <CardBody className='auth-card__body'>
                        {errorMessage&&<Alert color="danger">{errorMessage}</Alert>}
                        <Form onSubmit={submitRegister}>
                            <FormGroup>
                                <Label>Company ID</Label>
                                <Input 
                                    type = "text"
                                    placeholder = "Company ID"
                                    defaultValue={company_id}
                                    onChange = {e => setCompany_id(e.target.value)}
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Full Name</Label>
                                <Input 
                                    type = "text"
                                    placeholder = "Full Name"
                                    defaultValue={name}
                                    onChange = {e => setName(e.target.value)}
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Email</Label>
                                <Input 
                                    type = "email"
                                    placeholder = "Requires Unique Email"
                                    defaultValue={email}
                                    onChange = {e => setEmail(e.target.value)}
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for = "password" >Password</Label>
                                <Input 
                                    type = "password"
                                    placeholder = "Password"
                                    defaultValue={password}
                                    onChange = {e => setPassword(e.target.value)}
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for = "password2" >Confirm Password</Label>
                                <Input 
                                    type = "password"
                                    placeholder = "Confirm Password"
                                    defaultValue={password2}
                                    onChange = {e => setPassword2(e.target.value)}
                                    required
                                />
                            </FormGroup>
                            <Button
                                color= "dark"
                                className='w-100 mt-4'
                                block
                            >
                                Register
                            </Button>
                        </Form>
                    </CardBody>
                </Card>
            </div>
        )
}

export default AdminRegister
